import { Box } from '@chakra-ui/react';

export function CheckGlyph() {
  return (
    <Box as='span' display='inline-flex' height='100%' width='100%'>
      <svg fill='none' height='100%' viewBox='0 0 18 18' width='100%' xmlns='http://www.w3.org/2000/svg'>
        <path
          d='M15.375 4.875L7.125 13.125L3.375 9.375'
          stroke='currentColor'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='1.5'
        />
      </svg>
    </Box>
  );
}
